import { i18n, getLocale } from '@src/localization';
// eslint-disable-next-line camelcase
import { query_string } from '@vkplay/shared';

const availableLanguages = ['en', 'de', 'fr', 'es', 'pl', 'ru', 'tr'];

let defaultLanguage = 'en';
if (window.location.href.indexOf('/gamecenter/download') > -1) {
  defaultLanguage = 'ru';
}


export const state = {
  // Application
  appWidth: window.innerWidth,

  currentLanguage: defaultLanguage,
};

export const getters = {
  // App size
  getAppSize: (state) => {
    let size = 'xl';

    if (state.appWidth < 718) {
      size = 'sm';
    } else if (state.appWidth < 1062) {
      size = 'md';
    } else if (state.appWidth < 1330) {
      size = 'lg';
    }
    return size;
  },
  getCurrentLang: (state) => state.currentLanguage,
  isMac: () => navigator.appVersion.indexOf('Mac') !== -1,
  isLinkGameCenter: () => {
    const search = query_string(window.location.search);
    const { from } = search;

    return from === 'gamecenter';
  },
  appIsLarge: (state, getters) => ['xl', 'lg'].includes(getters.getAppSize),
  appIsSmall: (state, getters) => ['sm', 'md'].includes(getters.getAppSize),
  appIsExtraLarge: (state, getters) => getters.getAppSize === 'xl',
  appIsMobile: (state, getters) => getters.getAppSize === 'sm',
  appIsTablet: (state, getters) => getters.getAppSize === 'md',
};

export const mutations = {
  SET_APP_WIDTH(state, newValue) {
    state.appWidth = newValue;
  },

  SET_CURRENT_LANGUAGE(state, language) {
    const newLanguage = language && (language === 'ar' || availableLanguages.includes(language)) ? language : defaultLanguage;

    state.currentLanguage = newLanguage;

    if (language && language === 'ar') {
      document.dir = 'rtl';
    }

    i18n.locale = newLanguage;
  },
};

export const actions = {
  init({ commit }) {
    commit('SET_CURRENT_LANGUAGE', getLocale().lang);
  },
};
